import { customElement, property, queryAssignedElements } from 'lit/decorators.js';
import {html, LitElement} from "lit";
import {telephoneNumberInputStyles} from "@/components/telephone-number-input/telephone-number-input.styles";
import {SbkInput} from "@/components/input/input";
import {SbkSelect} from "@/components/select/select";
import {FormValidationMixin} from "@/components/mixins/form-validation-mixin";
import {SbkLabelMixin} from "@/components/label/label-mixin";
import { when } from 'lit/directives/when.js';
import {labelStyles} from "@/components/label/label.styles";
import {FormControlDependencyMixin} from "@/components/form-control-dependency/form-control-dependency-mixin";
import {unsafeHTML} from "lit/directives/unsafe-html.js";

/**
 * An example element.
 *
 * @slot - This element has a slot
 */
@customElement('sbk-telephone-number-input')
export class SbkTelephoneNumberInput extends FormControlDependencyMixin(FormValidationMixin(SbkLabelMixin(LitElement))) {

    static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

    @queryAssignedElements({slot: 'countryCodeSelect'})
    _telephoneNumberCountryCodeSelect!: Array<SbkSelect>;

    @queryAssignedElements({slot: 'nationalNumberInput'})
    _telephoneNumberNationalNumberInput!: Array<SbkInput>;

    @property({type: Boolean})
    disabled: boolean = false

    @property()
    name: string = ''

    @property()
    description: string = ''

    @property({attribute: 'inputs-among-each'})
    inputsAmongEach: boolean = false

    constructor() {
        super();
        this.addEventListener('form-control-dependency-show', () => {
            this._telephoneNumberCountryCodeSelect[0].show();
            this._telephoneNumberCountryCodeSelect[0].setValue();
            this._telephoneNumberNationalNumberInput[0].show();
            this._telephoneNumberNationalNumberInput[0].setValue();
            this.show();
        });
        this.addEventListener('form-control-dependency-hide', () => {
            this._telephoneNumberCountryCodeSelect[0].hide();
            this._telephoneNumberCountryCodeSelect[0].resetValue();
            this._telephoneNumberNationalNumberInput[0].hide();
            this._telephoneNumberNationalNumberInput[0].resetValue();
            this.hide();
        });
    }

    static get styles() {
        return [
            labelStyles,
            telephoneNumberInputStyles
        ];
    }

    render() {
        return html`
            <fieldset class="input__wrapper${this.invalid ? ' input__wrapper--error' : ''}${this.disabled ? ' input__wrapper--disabled' : ''}" aria-describedby="${this.name}-annotation" aria-labelledby="groupLabel">
                ${this.labelTemplate("groupLabel", true)}
                ${when(this.description,
                        () => html`
                            <sbk-annotation id="${this.name}-annotation" variant="info" ?disabled=${this.disabled}>${unsafeHTML(this.description)}</sbk-annotation>
                        `)}
                ${this.invalid ? this.validationErrorTemplate(`${this.name}-annotation`) : ""}
                <slot name="typeSelect"></slot>
                <div class="row${this.inputsAmongEach ? ' among-each-other' : ''}">
                    <div class=${!this.inputsAmongEach ? 'countryCodeSelect' : ''}>
                        <slot @slotchange=${this._onSlotChange} @select-value-changed=${this._onCountryCodeChange} name="countryCodeSelect"></slot>
                    </div>
                    <div class=${!this.inputsAmongEach ? 'nationalNumberInput' : ''}>
                        <slot @input-change=${this._onNationalInputChange} name="nationalNumberInput"></slot>
                    </div>
                </div>
            </fieldset>
        `;
    }

    _onSlotChange() {
        this._telephoneNumberCountryCodeSelect[0].enableSearch = true;
    }

    _onCountryCodeChange() {
        this.invalid = false;
    }

    _onNationalInputChange() {
        if (this._telephoneNumberCountryCodeSelect[0].selectedOption.value === '+49') {
            this._telephoneNumberNationalNumberInput[0].value = this._telephoneNumberNationalNumberInput[0].value.replace(/^0/, '')
        }
        this.invalid = false;
    }

    hide(): void {
        this.hidden = true;
        this.invalid = false;
    }

    show(): void {
        this.hidden = false;
    }
}
